import React from 'react';
import NumberFormat from 'react-number-format';

interface NumberFormatProps {
    inputRef: (instance: NumberFormat | null) => void,
  name: string,
  onChange: (event: { target: { name: string; value: string; }}) => void,
}

const MoneyField: React.FC<NumberFormatProps> = (props: NumberFormatProps) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <>
      <NumberFormat
        {...other}
        decimalScale={2}
        fixedDecimalScale={true}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        //isNumericString
        prefix="$ "
      />
    </>
  );

}

export default MoneyField;